export default __webpack_public_path__ + "static/media/gallery-wip-blade plug pin_03.523a3a47.jpg";